import type { Context } from '../../types';
import { SET_CONTEXT } from './project-access-context-type';

export const setContext = (payload: Context) => ({
	type: SET_CONTEXT,
	payload,
});

export type Action = ReturnType<typeof setContext>;
